import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/OrderDownload.css";
import FirmaOficial from "../../Photos/firma.png"
import PhoneIcon from "../../Photos/PhoneIcon.png"
import EmailIcon from "../../Photos/EmailIcon.png"
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { Modal } from 'flowbite-react';
import examslist from "../../../JSONS/updatedExams.json"
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import { jwtDecode }  from 'jwt-decode';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Logo from "../../Photos/YMC_Logo_PDF.png";
import TinyLogo from "../../Photos/YMCTinyLogo.svg";
import IconLab from "../../Photos/IconLaboratory.svg";
import IconIma from "../../Photos/IconImagenology.svg";
import IconDer from "../../Photos/IconDerivations.svg";

const OrderRecoveryCreator = () => {

    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
    const Name = decodedToken ? decodedToken.name : null
    const Rut = decodedToken ? decodedToken.rut : null
    const Gender = decodedToken ? parseInt(decodedToken.gender) : null;
    const now = (new Date()).getTime()
    const [Age,setAge] = useState(0)
    const [DateMedical,setDateMedical] = useState(new Date())
    const [OneTime,setOneTime] = useState(true)
    const [OrderExamsCodes,setOrderExamsCodes] = useState([])
    const [MedicalOrders,setMedicalOrders] = useState([])

    const [Loading, setLoading] = useState(false);
    const [LoadingImages, setLoadingImages] = useState(false);
    const [LoadingImage1, setLoadingImage1] = useState(false);
    const [LoadingImage2, setLoadingImage2] = useState(false);

    useEffect(() => {
        if(LoadingImage1 && LoadingImage2) {
        setLoadingImages(false)
        setLoadingImage1(false)
        setLoadingImage2(false)
        }
    }, [LoadingImage1, LoadingImage2])

    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"];

    const [openModal, setOpenModal] = useState(false);
    const [orderChosen, setOrderChosen] = useState(false);
    const [HowMany, setHowMany] = useState(0);

    function PDFstuff() {
        const pdf = new jsPDF();

        let manyExams = 0
        if(orderChosen === "Imagenología y Procedimientos") {
        manyExams = OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length
        } else {
        manyExams = OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen).length
        }

        if(manyExams > 16) {
        Promise.all([
            html2canvas(document.getElementById('myPage'), { quality: 0.8 }),
            html2canvas(document.getElementById('myPage2'), { quality: 0.8 })
        ])
        .then(function([blob1,  blob2]) {
            let imgProps= pdf.getImageProperties(blob1);
            let pdfWidth = pdf.internal.pageSize.getWidth();
            let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(blob1, 'PNG', 0, 0,pdfWidth, pdfHeight);

            pdf.addPage()
            imgProps= pdf.getImageProperties(blob2);
            pdfWidth = pdf.internal.pageSize.getWidth();
            pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(blob2, 'PNG', 0, 0,pdfWidth, pdfHeight);
            pdf.save("Orden "+orderChosen+".pdf"); 
        });
        } else {
        html2canvas(document.getElementById('myPage'), { quality: 0.8 })
            .then(function (dataUrl) {
                const imgProps= pdf.getImageProperties(dataUrl);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                pdf.addImage(dataUrl, 0, 0,pdfWidth, pdfHeight);

                pdf.save("Orden "+orderChosen+".pdf"); 
            });
            }
    }

    const retrieveOrders = useCallback(async() => {
      setLoading(true)
      MySwal.fire({
        position: "center",
        html: 
        <div className="FullAlertWidth1">
            <div className="FullAlertUpTitle">Cargando Datos Históricos...</div>
            <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
        </div>,
        color: "#340066",
        customClass: 'swal-wide',
        showConfirmButton: false,
        width: "100%",
      })

      let params = {
        rut: decodedToken.rut,
        skip: 0,
        limit: 0
      };
      
      let requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(params)
      };
      
      try{
          
        const resp = await fetch("https://ymc-doc-api.azurewebsites.net/getusermedicalorders", requestOptions)

        const data = await resp.json();
        if(data) {
          console.log(data.results)
          setMedicalOrders([...data.results].reverse())
          setLoading(false)
          MySwal.close()
        }
      } catch(error){
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error al cargar los datos",
            text: "Por favor inténtelo más tarde",
            showConfirmButton: true
          });
          console.log(error)
          setLoading(false)
          MySwal.close()
          return false
      }
    },[MySwal, decodedToken])

    useEffect(() => {
      if(OneTime) {
        retrieveOrders()
        setOneTime(false)
      }
    }, [OneTime, retrieveOrders])

    return (
    <>
    <div className="OrderCheckoutOuterDiv">
    <div className="UserProfileInnerDiv">
     <div className='UserProfileInnerDivCalculatorWhiteBlock' id="FullForm" style={{color:"#330066"}}>
    {Loading && MedicalOrders.length === 0 ? 
      null
    : MedicalOrders.length === 0 ?
      <div className="OrderDownloadCreator">
        <div className='UserWelcomeBlockPage1TitleFlex' style={{marginBlockStart:"0px"}}>
          <div className='UserWelcomeBlockPage1Title' style={{marginInline:"auto"}}>Órdenes Médicas</div>
        </div>
        <div className="OrderDownloadCreatorUpperFlex">
          <div className="OrderRecoveryCreatorUpperLeft">
            <h2 className="OrderRecoveryTitle">Revisa y descarga las ordenes médicas que has comprado</h2>
            <div className="OrderRecoverySubtitle">Tu historial de órdenes médicas te permite también saber cuales órdenes siguen siendo válidas a la fecha.</div>
          </div>
          <img alt="" className="OrderDownloadCreatorUpperRight" src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
        </div>
        <div className='OrderRecoveryLowerSingleBlock'>
          <h3 className="OrderCheckoutTitle" style={{marginInline:"auto", textAlign:"center"}}>No has emitido ninguna orden médica</h3>
          <div className="OrderCheckoutEmptyInfo">¿No sabes por donde empezar? Explora nuestros packs de exámenes:</div>
          <div className="GeneralPurpleButtonFlex OrderCheckoutEmptyButton" onClick={() => Navigate("/packs-de-examenes")}>Ver Packs de Exámenes</div>
          <div className="OrderCheckoutEmptyInfo">O crea una orden personalizada contestando un par de preguntas:</div>
          <div className="GeneralPurpleButtonFlex OrderCheckoutEmptyButton" onClick={() => Navigate("/recomendador-de-examenes")}>Obtén tu Recomendación de Exámenes</div>
        </div>
      </div>
    :
      <div className="OrderDownloadCreator">
        <div className='UserWelcomeBlockPage1TitleFlex' style={{marginBlockStart:"0px"}}>
          <div className='UserWelcomeBlockPage1Title' style={{marginInline:"auto"}}>Órdenes Médicas</div>
        </div>
        <div className="OrderDownloadCreatorUpperFlex">
          <div className="OrderRecoveryCreatorUpperLeft">
            <h2 className="OrderRecoveryTitle">Revisa y descarga las ordenes médicas que has comprado</h2>
            <div className="OrderRecoverySubtitle">Tu historial de órdenes médicas te permite también saber cuales órdenes siguen siendo válidas a la fecha.</div>
          </div>
          <img alt="" className="OrderDownloadCreatorUpperRight" src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
        </div>
        <div className='OrderRecoveryLowerBlocks'>
          {MedicalOrders.map((order) => (
          <div className='OrderRecoveryLowerSingleBlock' key={order.orderID}>
            <div className='OrderRecoveryLowerSingleBlockUpperFlex'>
              <div>
                <div className='OrderRecoveryLowerSingleBlockTitle'>Orden {order.orderID}</div>
                <div className='OrderRecoveryLowerSingleBlockDate'>Emisión: {(new Date(order.date)).getDate()} de {months[(new Date(order.date)).getMonth()]} {(new Date(order.date)).getFullYear()}</div>
              </div>
              <div className='OrderRecoveryLowerSingleBlockStatusDiv'>
              {Math.floor(((now - (new Date(order.date)).getTime()))/1000/60/60/24) > 60 ?
                <div className='OrderRecoveryLowerSingleBlockStatus' style={{color:"#FF4F53"}}>Expirada</div>
              : 
                <div className='OrderRecoveryLowerSingleBlockStatus' style={{color:"#8BC53F"}}>Vigente</div>
              }
                <div className='OrderRecoveryLowerSingleBlockDate'>Expira: {(new Date(order.date+(1000*60*60*24*60))).getDate()} de {months[(new Date(order.date+(1000*60*60*24*60))).getMonth()]} {(new Date(order.date+(1000*60*60*24*60))).getFullYear()}</div>
              </div>
            </div>
            <div className='OrderRecoveryLowerSingleBlockLowerFlex'>
              {order.exams.filter((Item) => examslist[Item].emission === 'Laboratorio').length > 0 ?
              <div className='GeneralWhiteButtonFlex OrderRecoveryLowerSingleBlockLowerButton' onClick={() => {setOrderExamsCodes(order.exams); setDateMedical(new Date(order.date)); setAge(parseInt(order.age)); setOrderChosen('Laboratorio'); setOpenModal(true); setLoadingImages(true); setHowMany(order.exams.filter((Item) => examslist[Item].emission === 'Laboratorio').length);}}>Laboratorio</div>
              : null}
              {order.exams.filter((Item) => examslist[Item].emission === 'Imagenología' | examslist[Item].emission === 'Procedimientos').length > 0 ?
              <div className='GeneralWhiteButtonFlex OrderRecoveryLowerSingleBlockLowerButton' onClick={() => {setOrderExamsCodes(order.exams); setDateMedical(new Date(order.date)); setAge(parseInt(order.age)); setOrderChosen('Imagenología y Procedimientos'); setOpenModal(true); setLoadingImages(true); setHowMany(order.exams.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length);}}>Imagenología y Procedimientos</div>
              : null}
              {order.exams.filter((Item) => examslist[Item].emission === 'Derivaciones').length > 0 ?
              <div className='GeneralWhiteButtonFlex OrderRecoveryLowerSingleBlockLowerButton' onClick={() => {setOrderExamsCodes(order.exams); setDateMedical(new Date(order.date)); setAge(parseInt(order.age)); setOrderChosen('Derivaciones'); setOpenModal(true); setLoadingImages(true); setHowMany(order.exams.filter((Item) => examslist[Item].emission === 'Derivaciones').length);}}>Derivaciones</div>
              : null}
            </div>
          </div>
          ))}
        </div>
        <Modal dismissible show={openModal} position="center" style={{marginBlock:"0px !important"}} className='OrderDownloadPreviewModal'>
            <Modal.Body className='OrderDownloadPreviewModalBody'>
              <div className='OrderDownloadPreviewModalHeaderTitle'>Preview Orden Médica {orderChosen}</div>
              <div className='OrderDownloadPreviewModalHeaderButtons'>
                {LoadingImages ? 
                <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalDownloadButton">Cargando...</div>
                :
                <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalDownloadButton" onClick={() => PDFstuff()}>DESCARGAR</div>
}
                <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalCloseButton" onClick={() => setOpenModal(false)}>CERRAR</div>
              </div>
              <div className="OrderDownloadPreviewModalPDFContainer">
                <div id="myPage" className="OrderDownloadPreviewModalPDF">
                  <div className="OrderDownloadPreviewModalPDFUpperRow" style={{paddingBlockEnd:"12px"}}>
                    <div className="OrderDownloadPreviewModalPDFUpperLeftSide">
                      <div className="OrderDownloadPreviewModalPDFUpperLeftSidePageNumber">1/{HowMany > 16 ? 2 : 1}</div>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFUpperRightTexts">
                      <img className="OrderDownloadPreviewModalPDFUpperRightLogo" alt='' src={TinyLogo} onLoad={() => setLoadingImage1(true)}/>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFUpperRow" style={{paddingBlockStart:"8px"}}>
                    <div className="OrderDownloadPreviewModalPDFUpperLeftSide">
                      <h2 className="OrderDownloadPreviewModalPDFUpperUpperLeftTitle">Orden Médica {orderChosen}</h2>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFUpperRightTexts">
                      <div className="OrderDownloadPreviewModalPDFUpperUpperRightOrderText">Fecha de emisión</div>
                      <div className="OrderDownloadPreviewModalPDFUpperUpperRightText1">{DateMedical.getDate()} de {months[DateMedical.getMonth()]} {DateMedical.getFullYear()}</div>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFHorizontalLine"></div>
                  <div className="OrderDownloadPreviewModalPDFPatientData">
                    <div className="OrderDownloadPreviewModalPDFPatientDataTitle" style={{marginBlock:"10px"}}>Paciente</div>
                    <div className="OrderDownloadPreviewModalPDFPatientDataName">
                      Nombre: {Name}
                    </div>
                    <div className="OrderDownloadPreviewModalPDFPatientDataSecondRow">
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Rut: {Rut}
                      </div>
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Edad: {Age}
                      </div>
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Sexo: {Gender === 1 ? 'Hombre' : 'Mujer'}
                      </div>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFHorizontalLine" style={{paddingBlockEnd:"8px"}}></div>
                  {orderChosen === "Imagenología y Procedimientos" ?
                  <>
                    <div className="OrderDownloadPreviewModalPDFExamsDataUpperFlexDiv">
                      <div className="OrderDownloadPreviewModalPDFPatientDataTitle">Exámenes {orderChosen}</div>
                      <div className="OrderDownloadPreviewModalPDFExamsDataRightFlex">
                        <div className="OrderDownloadPreviewModalPDFExamsDataNumber">({OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length})</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataIconDiv">
                          <img alt="" className="OrderDownloadPreviewModalPDFExamsDataIcon" src={IconIma} />
                        </div>
                      </div>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDivContainer">
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDiv">
                    {[...Array(OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length).keys()].map((object) => {
                      return (
                    <>
                    {object < 16 ?
                    <div className="OrderDownloadPreviewModalPDFExamsDataOneExam" key={object}>
                      <div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamName">
                          {examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos")[object]].name}</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamPreparation">{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos")[object]].prep === "No necesita preparación" ? null : "Preparación: "}{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos")[object]].prep} </div>
                      </div>
                    </div>
                    : null}
                    </>
)})}
                  </div>
                  </div>
                  </>
                    :
                    <>
                    <div className="OrderDownloadPreviewModalPDFExamsDataUpperFlexDiv">
                      <div className="OrderDownloadPreviewModalPDFPatientDataTitle">{orderChosen === "Derivaciones" ? "Derivaciones" : "Exámenes Laboratorio"}</div>
                      <div className="OrderDownloadPreviewModalPDFExamsDataRightFlex">
                        <div className="OrderDownloadPreviewModalPDFExamsDataNumber">({OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen).length})</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataIconDiv">
                          <img alt="" className="OrderDownloadPreviewModalPDFExamsDataIcon" src={orderChosen === "Derivaciones" ? IconDer : IconLab} />
                        </div>
                      </div>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDivContainer">
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDiv">
                      {[...Array(OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen).length).keys()].map((object) => {
                        return (
                      <>
                      {object < 16 ?
                      <div className="OrderDownloadPreviewModalPDFExamsDataOneExam" key={object}>
                        <div>
                          <div className="OrderDownloadPreviewModalPDFExamsDataExamName">
                            {examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen)[object]].name}</div>
                          <div className="OrderDownloadPreviewModalPDFExamsDataExamPreparation">{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen)[object]].prep === "No necesita preparación" ? null : "Preparación: "}{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen)[object]].prep} </div>
                        </div>
                      </div>
                      : null}
                      </>
  )})}
                    </div>
                    </div>
                    </>
}
                  <div className="OrderDownloadPreviewModalPDFSignatureDiv">
                    <img className="OrderDownloadPreviewModalPDFSignatureImage" alt='' src={FirmaOficial} onLoad={() => setLoadingImage2(true)}/>
                    <div className="OrderDownloadPreviewModalPDFDoctorName" >Jorge Caro Díaz</div>
                    <div className="OrderDownloadPreviewModalPDFDoctorName" >Médico-Cirujano</div>
                    <div className="OrderDownloadPreviewModalPDFDoctorName" >RUT: 15.946.308-7&emsp;RCM: 27978-1</div>
                    
                  </div>
                  <div className="OrderDownloadPreviewModalPDFContactDiv">
                    <div className="OrderDownloadPreviewModalPDFContactFlex">
                      <div className="OrderDownloadPreviewModalPDFContactLeft">
                        <img className="OrderDownloadPreviewModalPDFContactLeftLogo" alt='' src={Logo} />
                      </div>
                      <div className="OrderDownloadPreviewModalPDFContactRight">
                        <div className="OrderDownloadPreviewModalPDFContactText">En caso de dudas o consultas, <span style={{fontWeight:"700"}}>contáctanos</span></div>
                        <div className="OrderDownloadPreviewModalPDFContactRightFlex">
                          <img className="OrderDownloadPreviewModalPDFContactIcon" alt='' src={PhoneIcon} />
                          <div className="OrderDownloadPreviewModalPDFContactLowerText">+56 9 7127 3898 </div>
                        </div>
                        <div className="OrderDownloadPreviewModalPDFContactRightFlex">
                          <img className="OrderDownloadPreviewModalPDFContactIcon" alt='' src={EmailIcon} />
                          <div className="OrderDownloadPreviewModalPDFContactLowerText">contacto@yomecontrolo.cl </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {HowMany > 16 ? 
              <div className="OrderDownloadPreviewModalPDFContainer">
              <div id="myPage2" className="OrderDownloadPreviewModalPDF">
              <div className="OrderDownloadPreviewModalPDFUpperRow" style={{paddingBlockEnd:"12px"}}>
                    <div className="OrderDownloadPreviewModalPDFUpperLeftSide">
                      <div className="OrderDownloadPreviewModalPDFUpperLeftSidePageNumber">2/{HowMany > 16 ? 2 : 1}</div>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFUpperRightTexts">
                      <img className="OrderDownloadPreviewModalPDFUpperRightLogo" alt='' src={TinyLogo} onLoad={() => setLoadingImage1(true)}/>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFUpperRow" style={{paddingBlockStart:"8px"}}>
                    <div className="OrderDownloadPreviewModalPDFUpperLeftSide">
                      <h2 className="OrderDownloadPreviewModalPDFUpperUpperLeftTitle">Orden Médica {orderChosen}</h2>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFUpperRightTexts">
                      <div className="OrderDownloadPreviewModalPDFUpperUpperRightOrderText">Fecha de emisión</div>
                      <div className="OrderDownloadPreviewModalPDFUpperUpperRightText1">{DateMedical.getDate()} de {months[DateMedical.getMonth()]} {DateMedical.getFullYear()}</div>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFHorizontalLine"></div>
                  <div className="OrderDownloadPreviewModalPDFPatientData">
                    <div className="OrderDownloadPreviewModalPDFPatientDataTitle" style={{marginBlock:"10px"}}>Paciente</div>
                    <div className="OrderDownloadPreviewModalPDFPatientDataName">
                      Nombre: {Name}
                    </div>
                    <div className="OrderDownloadPreviewModalPDFPatientDataSecondRow">
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Rut: {Rut}
                      </div>
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Edad: {Age}
                      </div>
                      <div className="OrderDownloadPreviewModalPDFPatientDataName">
                        Sexo: {Gender === 1 ? 'Hombre' : 'Mujer'}
                      </div>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFHorizontalLine" style={{paddingBlockEnd:"8px"}}></div>
                {orderChosen === "Imagenología y Procedimientos" ?
                  <>
                    <div className="OrderDownloadPreviewModalPDFExamsDataUpperFlexDiv">
                      <div className="OrderDownloadPreviewModalPDFPatientDataTitle">Exámenes {orderChosen}</div>
                      <div className="OrderDownloadPreviewModalPDFExamsDataRightFlex">
                        <div className="OrderDownloadPreviewModalPDFExamsDataNumber">({OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length})</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataIconDiv">
                          <img alt="" className="OrderDownloadPreviewModalPDFExamsDataIcon" src={IconIma} />
                        </div>
                      </div>
                    </div>
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDivContainer">
                    <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDiv">
                    {[...Array(OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos").length).keys()].map((object) => {
                      return (
                    <>
                    {object > 15 ?
                    <div className="OrderDownloadPreviewModalPDFExamsDataOneExam" key={object}>
                      <div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamName">
                          {examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos")[object]].name}</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamPreparation">{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === "Imagenología" | examslist[Item].emission === "Procedimientos")[object]].prep} </div>
                      </div>
                    </div>
                    : null}
                    </>
)})}
                  </div>
                  </div>
                  </>
                    :
                    <>
                  <div className="OrderDownloadPreviewModalPDFExamsDataUpperFlexDiv">
                    <div className="OrderDownloadPreviewModalPDFPatientDataTitle">{orderChosen === "Derivaciones" ? "Derivaciones" : "Exámenes Laboratorio"}</div>
                    <div className="OrderDownloadPreviewModalPDFExamsDataRightFlex">
                      <div className="OrderDownloadPreviewModalPDFExamsDataNumber">({OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen).length})</div>
                      <div className="OrderDownloadPreviewModalPDFExamsDataIconDiv">
                        <img alt="" className="OrderDownloadPreviewModalPDFExamsDataIcon" src={orderChosen === "Derivaciones" ? IconDer : IconLab} />
                      </div>
                    </div>
                  </div>
                  <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDivContainer">
                  <div className="OrderDownloadPreviewModalPDFExamsDataLowerFlexDiv">
                    {[...Array(OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen).length).keys()].map((object) => {
                      return (
                    <>
                    {object > 15 ?
                    <div className="OrderDownloadPreviewModalPDFExamsDataOneExam" key={object}>
                      <div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamName">
                          {examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen)[object]].name}</div>
                        <div className="OrderDownloadPreviewModalPDFExamsDataExamPreparation">{examslist[OrderExamsCodes.filter((Item) => examslist[Item].emission === orderChosen)[object]].prep} </div>
                      </div>
                    </div>
                    : null}
                    </>
)})}
                  </div>
                  </div>
                  </>
}
                <div className="OrderDownloadPreviewModalPDFSignatureDiv">
                  <img className="OrderDownloadPreviewModalPDFSignatureImage" alt='' src={FirmaOficial}/>
                  <div className="OrderDownloadPreviewModalPDFDoctorName" >Jorge Caro Díaz</div>
                  <div className="OrderDownloadPreviewModalPDFDoctorName" >Médico-Cirujano</div>
                  <div className="OrderDownloadPreviewModalPDFDoctorName" >RUT: 15.946.308-7&emsp;RCM: 27978-1</div>
                </div>
                <div className="OrderDownloadPreviewModalPDFContactDiv">
                  <div className="OrderDownloadPreviewModalPDFContactFlex">
                    <div className="OrderDownloadPreviewModalPDFContactLeft">
                      <img className="OrderDownloadPreviewModalPDFContactLeftLogo" alt='' src={Logo} />
                    </div>
                    <div className="OrderDownloadPreviewModalPDFContactRight">
                      <div className="OrderDownloadPreviewModalPDFContactText">En caso de dudas o consultas, <span style={{fontWeight:"700"}}>contáctanos</span></div>
                      <div className="OrderDownloadPreviewModalPDFContactRightFlex">
                        <img className="OrderDownloadPreviewModalPDFContactIcon" alt='' src={PhoneIcon} />
                        <div className="OrderDownloadPreviewModalPDFContactLowerText">+56 9 7127 3898 </div>
                      </div>
                      <div className="OrderDownloadPreviewModalPDFContactRightFlex">
                        <img className="OrderDownloadPreviewModalPDFContactIcon" alt='' src={EmailIcon} />
                        <div className="OrderDownloadPreviewModalPDFContactLowerText">contacto@yomecontrolo.cl </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> : null
              }
            </Modal.Body>
            <Modal.Footer>
              <div className="OrderDownloadPreviewModalFooter">
                <div className="GeneralPurpleButtonFlex OrderDownloadPreviewModalFooterCloseButton" onClick={() => setOpenModal(false)}>CERRAR</div>
              </div>
            </Modal.Footer>
        </Modal>
      </div>
      }
      </div>
      </div>
      </div>
    </>
  );
};

export default OrderRecoveryCreator;